var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCovidLowRisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 457,
    height: 457,
    viewBox: "0 0 457 457",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6508_4277)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_6508_4277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.721 107.776C231.721 107.776 237.765 79.5539 218.429 64.5152C199.094 49.4766 179.757 49.4766 179.757 32.289C179.757 15.1013 187.407 3.37256 187.407 3.37256C187.407 3.37256 160.014 25.7292 160.422 45.18C161.041 74.7147 182.63 76.0898 183.327 87.6387C184.13 100.931 175.753 118.518 175.753 118.518L231.721 107.776Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M231.721 107.776C231.721 107.776 237.765 79.5539 218.429 64.5152C199.094 49.4766 179.757 49.4766 179.757 32.289C179.757 15.1013 187.407 3.37256 187.407 3.37256C187.407 3.37256 160.014 25.7292 160.422 45.18C161.041 74.7147 182.63 76.0898 183.327 87.6387C184.13 100.931 175.753 118.518 175.753 118.518L231.721 107.776Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.987 11.3737C178.857 20.3491 176.788 30.4919 179.711 39.7533C184.522 49.6833 196.192 52.4473 205.012 57.6905C215.701 63.1594 226.154 71.2129 229.162 83.4356C231.472 90.8895 231.644 98.884 230.402 106.552L178.283 116.503C182.293 106.428 186.345 95.3368 184.103 84.3991C180.069 75.846 169.932 72.0952 166.193 63.1777C160.213 52.166 160.551 37.9167 167.87 27.5987C171.881 20.9461 177.024 15.3207 182.522 9.94556L181.986 11.3735L181.987 11.3737Z",
    fill: "url(#paint0_linear_6508_4277)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_6508_4277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.724 348.746C224.724 348.746 218.68 376.968 238.016 392.007C257.351 407.046 276.688 407.046 276.688 424.233C276.688 441.421 269.038 453.15 269.038 453.15C269.038 453.15 296.431 430.793 296.023 411.342C295.404 381.807 273.815 380.432 273.118 368.884C272.315 355.592 280.692 338.004 280.692 338.004L224.724 348.746Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M224.724 348.746C224.724 348.746 218.68 376.968 238.016 392.007C257.351 407.046 276.688 407.046 276.688 424.233C276.688 441.421 269.038 453.15 269.038 453.15C269.038 453.15 296.431 430.793 296.023 411.342C295.404 381.807 273.815 380.432 273.118 368.884C272.315 355.592 280.692 338.004 280.692 338.004L224.724 348.746Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.458 445.148C277.588 436.173 279.657 426.03 276.734 416.769C271.923 406.839 260.253 404.075 251.433 398.832C240.744 393.363 230.291 385.309 227.283 373.087C224.973 365.633 224.802 357.638 226.043 349.97L278.162 340.02C274.152 350.094 270.1 361.185 272.342 372.123C276.376 380.676 286.513 384.427 290.252 393.345C296.232 404.356 295.895 418.606 288.575 428.924C284.564 435.576 279.421 441.201 273.923 446.577L274.459 445.149L274.458 445.148Z",
    fill: "url(#paint1_linear_6508_4277)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_6508_4277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.007 122.185C171.007 122.185 162.13 94.7213 137.866 91.3651C113.601 88.0089 96.8555 97.6771 88.2617 82.7921C79.6679 67.9071 80.4281 53.9249 80.4281 53.9249C80.4281 53.9249 67.8834 86.9828 77.9625 103.624C93.2655 128.892 112.65 119.288 119.028 128.942C126.369 140.051 127.909 159.471 127.909 159.471L171.007 122.185Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.007 122.185C171.007 122.185 162.13 94.7213 137.866 91.3651C113.601 88.0089 96.8555 97.6771 88.2617 82.7921C79.6679 67.9071 80.4281 53.9249 80.4281 53.9249C80.4281 53.9249 67.8834 86.9828 77.9625 103.624C93.2655 128.892 112.65 119.288 119.028 128.942C126.369 140.051 127.909 159.471 127.909 159.471L171.007 122.185Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7352 63.5641C81.5125 72.9018 84.7917 82.7205 91.9541 89.2794C101.086 95.4736 112.574 92.0324 122.834 92.1632C134.825 91.555 147.904 93.3032 156.621 102.384C162.349 107.685 166.494 114.522 169.253 121.784L129.092 156.461C127.527 145.731 125.491 134.1 118.08 125.748C110.31 120.358 99.6561 122.178 91.9588 116.325C81.2746 109.778 74.4419 97.2694 75.6217 84.674C75.7688 76.9073 77.4102 69.464 79.484 62.06L79.7342 63.5643L79.7352 63.5641Z",
    fill: "url(#paint2_linear_6508_4277)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_6508_4277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.495 334.337C285.495 334.337 294.372 361.801 318.636 365.157C342.901 368.513 359.647 358.845 368.241 373.73C376.834 388.615 376.074 402.597 376.074 402.597C376.074 402.597 388.619 369.539 378.54 352.898C363.237 327.63 343.852 337.234 337.474 327.58C330.133 316.471 328.593 297.051 328.593 297.051L285.495 334.337Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M285.495 334.337C285.495 334.337 294.372 361.801 318.636 365.157C342.901 368.513 359.647 358.845 368.241 373.73C376.834 388.615 376.074 402.597 376.074 402.597C376.074 402.597 388.619 369.539 378.54 352.898C363.237 327.63 343.852 337.234 337.474 327.58C330.133 316.471 328.593 297.051 328.593 297.051L285.495 334.337Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.767 392.958C374.99 383.62 371.711 373.802 364.548 367.243C355.417 361.049 343.928 364.49 333.668 364.359C321.677 364.967 308.598 363.219 299.881 354.138C294.154 348.838 290.008 342 287.249 334.738L327.41 300.062C328.975 310.791 331.012 322.422 338.422 330.774C346.192 336.164 356.846 334.344 364.543 340.197C375.228 346.744 382.06 359.253 380.881 371.848C380.733 379.615 379.092 387.058 377.018 394.462L376.768 392.958L376.767 392.958Z",
    fill: "url(#paint3_linear_6508_4277)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_6508_4277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.644 165.02C125.644 165.02 104.225 145.675 81.5332 154.901C58.8415 164.126 49.1733 180.872 34.2883 172.278C19.4033 163.685 13.0706 151.196 13.0706 151.196C13.0706 151.196 18.7357 186.097 35.7849 195.469C61.6721 209.7 73.6577 191.691 84.0078 196.862C95.9204 202.812 106.964 218.861 106.964 218.861L125.644 165.02Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M125.644 165.02C125.644 165.02 104.225 145.675 81.5332 154.901C58.8415 164.126 49.1733 180.872 34.2883 172.278C19.4033 163.685 13.0706 151.196 13.0706 151.196C13.0706 151.196 18.7357 186.097 35.7849 195.469C61.6721 209.7 73.6577 191.691 84.0078 196.862C95.9204 202.812 106.964 218.861 106.964 218.861L125.644 165.02Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2901 159.89C23.4982 167.088 31.2475 173.951 40.7298 176.05C51.735 176.849 59.9636 168.124 68.9145 163.108C78.9951 156.585 91.196 151.56 103.285 155.065C110.896 156.792 117.905 160.641 123.925 165.55L106.483 215.662C99.7629 207.152 92.1835 198.097 81.5902 194.57C72.1661 193.787 63.8493 200.69 54.2567 199.47C41.7305 199.143 29.5588 191.726 24.2828 180.228C20.5268 173.429 18.2266 166.162 16.3205 158.713L17.2894 159.89L17.2901 159.89Z",
    fill: "url(#paint4_linear_6508_4277)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_6508_4277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.858 291.502C330.858 291.502 352.277 310.847 374.969 301.622C397.661 292.396 407.329 275.65 422.214 284.244C437.099 292.838 443.432 305.327 443.432 305.327C443.432 305.327 437.767 270.425 420.717 261.053C394.83 246.822 382.844 264.831 372.494 259.661C360.582 253.71 349.538 237.662 349.538 237.662L330.858 291.502Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M330.858 291.502C330.858 291.502 352.277 310.847 374.969 301.622C397.661 292.396 407.329 275.65 422.214 284.244C437.099 292.838 443.432 305.327 443.432 305.327C443.432 305.327 437.767 270.425 420.717 261.053C394.83 246.822 382.844 264.831 372.494 259.661C360.582 253.71 349.538 237.662 349.538 237.662L330.858 291.502Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.212 296.632C433.004 289.434 425.255 282.571 415.772 280.472C404.767 279.673 396.539 288.398 387.588 293.415C377.507 299.937 365.306 304.962 353.217 301.457C345.606 299.73 338.597 295.881 332.578 290.972L350.019 240.86C356.739 249.37 364.319 258.425 374.912 261.952C384.336 262.735 392.653 255.832 402.245 257.052C414.772 257.379 426.943 264.796 432.219 276.294C435.975 283.094 438.276 290.36 440.182 297.809L439.213 296.632L439.212 296.632Z",
    fill: "url(#paint5_linear_6508_4277)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_6508_4277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.766 224.791C107.766 224.791 79.5439 218.748 64.5052 238.083C49.4666 257.419 49.4666 276.755 32.279 276.755C15.0913 276.755 3.36255 269.106 3.36255 269.106C3.36255 269.106 25.7192 296.498 45.17 296.09C74.7047 295.472 76.0798 273.882 87.6286 273.185C100.921 272.382 118.508 280.759 118.508 280.759L107.766 224.791Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.766 224.791C107.766 224.791 79.5439 218.748 64.5052 238.083C49.4666 257.419 49.4666 276.755 32.279 276.755C15.0913 276.755 3.36255 269.106 3.36255 269.106C3.36255 269.106 25.7192 296.498 45.17 296.09C74.7047 295.472 76.0798 273.882 87.6286 273.185C100.921 272.382 118.508 280.759 118.508 280.759L107.766 224.791Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3639 274.525C20.3392 277.655 30.482 279.724 39.7434 276.801C49.6734 271.99 52.4374 260.32 57.6806 251.5C63.1495 240.811 71.203 230.358 83.4257 227.35C90.8796 225.04 98.8741 224.869 106.542 226.11L116.493 278.229C106.418 274.219 95.3269 270.167 84.3892 272.409C75.8361 276.443 72.0853 286.58 63.1678 290.319C52.1561 296.299 37.9068 295.962 27.5888 288.642C20.9362 284.632 15.3109 279.489 9.93567 273.991L11.3636 274.526L11.3639 274.525Z",
    fill: "url(#paint6_linear_6508_4277)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_6508_4277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.736 231.731C348.736 231.731 376.958 237.775 391.997 218.439C407.036 199.104 407.036 179.767 424.223 179.767C441.411 179.767 453.14 187.417 453.14 187.417C453.14 187.417 430.783 160.024 411.332 160.432C381.797 161.051 380.422 182.64 368.874 183.337C355.582 184.14 337.994 175.763 337.994 175.763L348.736 231.731Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M348.736 231.731C348.736 231.731 376.958 237.775 391.997 218.439C407.036 199.104 407.036 179.767 424.223 179.767C441.411 179.767 453.14 187.417 453.14 187.417C453.14 187.417 430.783 160.024 411.332 160.432C381.797 161.051 380.422 182.64 368.874 183.337C355.582 184.14 337.994 175.763 337.994 175.763L348.736 231.731Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.138 181.997C436.163 178.867 426.02 176.798 416.759 179.721C406.829 184.532 404.065 196.202 398.822 205.022C393.353 215.711 385.299 226.164 373.077 229.172C365.623 231.482 357.628 231.654 349.96 230.412L340.01 178.293C350.084 182.303 361.175 186.355 372.113 184.113C380.666 180.079 384.417 169.942 393.335 166.203C404.346 160.223 418.596 160.561 428.914 167.88C435.566 171.891 441.191 177.034 446.567 182.532L445.139 181.996L445.138 181.997Z",
    fill: "url(#paint7_linear_6508_4277)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_6508_4277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.175 285.505C122.175 285.505 94.7113 294.382 91.3551 318.646C87.999 342.911 97.6671 359.657 82.7821 368.251C67.8971 376.844 53.915 376.084 53.915 376.084C53.915 376.084 86.9729 388.629 103.614 378.55C128.882 363.247 119.278 343.862 128.932 337.484C140.041 330.143 159.461 328.603 159.461 328.603L122.175 285.505Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M122.175 285.505C122.175 285.505 94.7113 294.382 91.3551 318.646C87.999 342.911 97.6671 359.657 82.7821 368.251C67.8971 376.844 53.915 376.084 53.915 376.084C53.915 376.084 86.9729 388.629 103.614 378.55C128.882 363.247 119.278 343.862 128.932 337.484C140.041 330.143 159.461 328.603 159.461 328.603L122.175 285.505Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5541 376.777C72.8919 375 82.7105 371.72 89.2695 364.558C95.4637 355.427 92.0225 343.938 92.1532 333.678C91.545 321.687 93.2933 308.608 102.374 299.891C107.675 294.163 114.512 290.018 121.774 287.259L156.451 327.42C145.721 328.985 134.09 331.022 125.738 338.432C120.348 346.202 122.168 356.856 116.315 364.553C109.768 375.238 97.2594 382.07 84.664 380.89C76.8974 380.743 69.4541 379.102 62.05 377.028L63.5544 376.778L63.5541 376.777Z",
    fill: "url(#paint8_linear_6508_4277)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_6508_4277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.328 171.017C334.328 171.017 361.791 162.14 365.147 137.876C368.503 113.611 358.835 96.8654 373.72 88.2715C388.605 79.6777 402.587 80.438 402.587 80.438C402.587 80.438 369.529 67.8933 352.888 77.9724C327.62 93.2753 337.224 112.66 327.571 119.038C316.461 126.379 297.041 127.919 297.041 127.919L334.328 171.017Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M334.328 171.017C334.328 171.017 361.791 162.14 365.147 137.876C368.503 113.611 358.835 96.8654 373.72 88.2715C388.605 79.6777 402.587 80.438 402.587 80.438C402.587 80.438 369.529 67.8933 352.888 77.9724C327.62 93.2753 337.224 112.66 327.571 119.038C316.461 126.379 297.041 127.919 297.041 127.919L334.328 171.017Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.948 79.7451C383.61 81.5224 373.792 84.8016 367.233 91.964C361.039 101.096 364.48 112.584 364.349 122.844C364.957 134.835 363.209 147.914 354.128 156.631C348.828 162.359 341.99 166.504 334.728 169.263L300.052 129.102C310.781 127.537 322.412 125.501 330.764 118.09C336.154 110.32 334.334 99.666 340.187 91.9687C346.734 81.2845 359.243 74.4518 371.838 75.6316C379.605 75.7787 387.048 77.4201 394.452 79.4939L392.948 79.7441L392.948 79.7451Z",
    fill: "url(#paint9_linear_6508_4277)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_6508_4277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.01 330.873C165.01 330.873 145.665 352.293 154.891 374.985C164.116 397.676 180.862 407.345 172.269 422.23C163.675 437.115 151.186 443.447 151.186 443.447C151.186 443.447 186.087 437.782 195.459 420.733C209.69 394.846 191.681 382.86 196.852 372.51C202.802 360.598 218.851 349.554 218.851 349.554L165.01 330.873Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M165.01 330.873C165.01 330.873 145.665 352.293 154.891 374.985C164.116 397.676 180.862 407.345 172.269 422.23C163.675 437.115 151.186 443.447 151.186 443.447C151.186 443.447 186.087 437.782 195.459 420.733C209.69 394.846 191.681 382.86 196.852 372.51C202.802 360.598 218.851 349.554 218.851 349.554L165.01 330.873Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.88 439.228C167.078 433.02 173.941 425.27 176.04 415.788C176.839 404.783 168.115 396.554 163.098 387.603C156.575 377.523 151.55 365.322 155.056 353.232C156.782 345.622 160.631 338.613 165.54 332.593L215.652 350.035C207.142 356.755 198.088 364.334 194.56 374.928C193.777 384.352 200.68 392.669 199.46 402.261C199.133 414.787 191.716 426.959 180.218 432.235C173.419 435.991 166.152 438.291 158.703 440.197L159.881 439.229L159.88 439.228Z",
    fill: "url(#paint10_linear_6508_4277)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_6508_4277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.496 125.654C291.496 125.654 310.842 104.235 301.616 81.5432C292.39 58.8515 275.644 49.1834 284.238 34.2984C292.832 19.4133 305.321 13.0806 305.321 13.0806C305.321 13.0806 270.42 18.7457 261.048 35.7949C246.816 61.6821 264.826 73.6677 259.655 84.0178C253.704 95.9304 237.656 106.974 237.656 106.974L291.496 125.654Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M291.496 125.654C291.496 125.654 310.842 104.235 301.616 81.5432C292.39 58.8515 275.644 49.1834 284.238 34.2984C292.832 19.4133 305.321 13.0806 305.321 13.0806C305.321 13.0806 270.42 18.7457 261.048 35.7949C246.816 61.6821 264.826 73.6677 259.655 84.0178C253.704 95.9304 237.656 106.974 237.656 106.974L291.496 125.654Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.627 17.3001C289.429 23.5082 282.565 31.2575 280.466 40.7398C279.668 51.745 288.392 59.9736 293.409 68.9245C299.931 79.0051 304.957 91.206 301.451 103.295C299.725 110.906 295.876 117.915 290.966 123.935L240.855 106.493C249.365 99.7729 258.419 92.1935 261.946 81.6002C262.73 72.1761 255.826 63.8593 257.046 54.2667C257.374 41.7405 264.791 29.5688 276.288 24.2928C283.088 20.5368 290.355 18.2366 297.804 16.3305L296.626 17.2994L296.627 17.3001Z",
    fill: "url(#paint11_linear_6508_4277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.543 229.306C101.543 261.919 115.005 293.195 138.967 316.256C162.93 339.316 195.429 352.272 229.317 352.272C263.205 352.272 295.704 339.316 319.666 316.256C343.629 293.195 357.091 261.919 357.091 229.306C357.091 196.694 343.629 165.417 319.666 142.356C295.704 119.296 263.205 106.341 229.317 106.341C195.429 106.341 162.93 119.296 138.967 142.356C115.005 165.417 101.543 196.694 101.543 229.306V229.306Z",
    fill: "#D45500"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_6508_4277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.492 113.424C283.02 114.091 331.378 149.021 345.565 197.758C358.921 243.084 340.646 295.889 301.288 322.291C261.805 350.765 204.312 353.17 163.284 326.269C130.498 305.736 107.796 268.208 108.667 228.815C108.697 187.886 132.538 148.514 168.428 129.41C187.734 118.48 210.16 112.834 232.493 113.422L232.492 113.424Z",
    fill: "url(#paint12_radial_6508_4277)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M102.04 226.171C102.04 258.783 115.502 290.06 139.464 313.121C163.426 336.181 195.926 349.136 229.814 349.136C263.701 349.136 296.201 336.181 320.163 313.121C344.126 290.06 357.587 258.783 357.587 226.171C357.587 193.558 344.126 162.282 320.163 139.221C296.201 116.16 263.701 103.205 229.814 103.205C195.926 103.205 163.426 116.16 139.464 139.221C115.502 162.282 102.04 193.558 102.04 226.171V226.171Z",
    fill: "#D45500"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_6508_4277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.492 113.424C283.02 114.091 331.378 149.021 345.565 197.758C358.921 243.084 340.646 295.889 301.288 322.291C261.805 350.765 204.312 353.17 163.284 326.269C130.498 305.736 107.796 268.208 108.667 228.815C108.697 187.886 132.538 148.514 168.428 129.41C187.734 118.48 210.16 112.834 232.493 113.422L232.492 113.424Z",
    fill: "url(#paint13_radial_6508_4277)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M309.484 158.265L233.759 189.998C245.035 212.214 271.208 243.57 293.618 232.549C318.867 226.94 322.076 189.122 309.484 158.265Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.4279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.913 192.564L136.314 201.675C140.874 226.169 157.153 263.628 181.76 259.368C207.568 261.1 221.302 225.718 217.913 192.565V192.564Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.4279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.12 190.008L228.538 190.352L222.331 191.368L217.851 192.616L218.297 197.453C224.18 197.479 229.989 197.08 235.202 193.253L234.12 190.008Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.4279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.8 164.791L241.215 191.855C250.832 210.804 273.156 237.545 292.268 228.145C313.804 223.361 316.54 191.107 305.8 164.791H305.8Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.21783
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.23 197.804L142.466 205.594C146.364 226.535 160.282 258.562 181.32 254.919C203.384 256.4 215.126 226.15 212.23 197.804V197.804Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.22081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.037 201.174L105.439 199.134L102.889 209.333L139.096 213.413L136.037 201.174Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.927 158.337L320.636 143.038L327.266 149.668L313.497 169.557L309.927 158.337Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.23 197.804L142.466 205.594C146.364 226.535 160.282 258.562 181.32 254.919C203.384 256.4 215.126 226.15 212.23 197.804V197.804Z",
    fill: "url(#paint14_linear_6508_4277)",
    stroke: "black",
    strokeWidth: 1.22081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.8 164.791L241.215 191.855C250.832 210.804 273.156 237.545 292.268 228.145C313.804 223.361 316.54 191.107 305.8 164.791H305.8Z",
    fill: "url(#paint15_linear_6508_4277)",
    stroke: "black",
    strokeWidth: 1.21783
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.119 280.251C296.119 280.251 282.747 306.996 263.357 313.013C243.968 319.03 229.259 315.687 218.561 311.675C207.864 307.664 199.172 298.303 199.172 298.303",
    stroke: "black",
    strokeWidth: 2.8558,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.051 276.595C290.051 276.595 293.578 275.943 296.119 277.482C298.66 279.021 299.966 280.788 300.792 282.193C301.617 283.599 301.809 285.203 301.809 285.203",
    stroke: "black",
    strokeWidth: 1.35591,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.553 304.225C194.553 304.225 194.118 300.919 195.792 298.632C197.465 296.345 199.29 295.215 200.728 294.514C202.167 293.813 203.765 293.71 203.765 293.71",
    stroke: "black",
    strokeWidth: 1.30113,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.821 150.957C290.468 150.977 288.115 150.972 285.762 150.97C279.069 150.984 272.374 150.963 265.683 151.16C264.532 151.194 262.347 151.951 261.137 152.232C259.001 152.538 257.116 153.504 255.373 154.727C254.085 156.086 252.514 157.072 251.182 158.381C249.863 159.921 248.476 161.35 247.388 163.077C246.455 165.138 244.549 166.152 242.968 167.604C241.922 168.538 240.567 168.793 239.235 169.057L255.112 171.139C256.526 170.647 257.858 170.053 258.935 168.973C260.686 167.54 262.281 166.041 263.39 164.028C264.521 162.474 265.851 161.093 267.177 159.706C268.532 158.542 269.952 157.439 271.362 156.346C273.106 155.374 274.928 154.686 276.913 154.362C277.695 154.179 278.99 153.864 279.77 153.733C280.296 153.645 281.889 153.537 281.356 153.525C256.338 152.988 264.557 153.535 269.973 153.471C272.272 153.47 274.572 153.464 276.872 153.484L292.821 150.957L292.821 150.957Z",
    fill: "#FF7F2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.201 177.475C207.676 177.584 205.175 177.441 202.671 177.129C194.825 176.251 186.764 175.731 178.943 176.882C178.564 176.937 178.167 176.921 177.805 177.048C176.604 177.468 174.458 179.172 173.204 179.898C171.016 180.822 168.707 181.587 166.376 182.08C163.831 182.486 161.252 182.561 158.681 182.598C153.114 182.591 145.067 182.89 171.032 182.565C171.59 182.558 169.634 182.43 168.172 181.949C166.636 181.525 165.204 180.831 163.706 180.303L147.776 182.365C149.351 182.725 150.732 183.457 152.259 183.938C152.894 184.161 153.491 184.487 154.133 184.69C160.589 186.729 167.729 185.016 174.479 185.058C177.074 184.958 179.683 184.806 182.215 184.188C184.574 183.496 186.978 182.818 189.108 181.558C190.911 180.487 192.558 179.221 194.755 179.203C200.682 178.734 197 179.059 181.475 179.04C181.003 179.039 182.419 179.071 182.891 179.094C184.23 179.159 185.57 179.256 186.901 179.424C189.35 179.738 191.772 180.158 194.252 180.002L210.201 177.475V177.475Z",
    fill: "#FF7F2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.308 113.379C229.704 113.368 231.107 113.387 232.503 113.424C263.998 113.84 294.645 127.57 316.705 149.657C311.061 178.326 294.756 204.912 270.298 221.32C230.815 249.794 173.311 252.193 132.283 225.292C124.478 220.404 117.254 214.544 110.776 207.934C117.292 174.942 138.708 145.219 168.427 129.4C186.527 119.152 207.373 113.556 228.31 113.38L228.308 113.379Z",
    fill: "url(#paint16_linear_6508_4277)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6508_4277",
    x: 157.608,
    y: 0.562423,
    width: 77.8177,
    height: 120.766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.40507,
    result: "effect1_foregroundBlur_6508_4277"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_6508_4277",
    x: 221.02,
    y: 335.194,
    width: 77.8177,
    height: 120.766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.40507,
    result: "effect1_foregroundBlur_6508_4277"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_6508_4277",
    x: 71.2334,
    y: 51.1148,
    width: 102.584,
    height: 111.167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.40507,
    result: "effect1_foregroundBlur_6508_4277"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_6508_4277",
    x: 282.685,
    y: 294.241,
    width: 102.584,
    height: 111.167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.40507,
    result: "effect1_foregroundBlur_6508_4277"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_6508_4277",
    x: 10.2604,
    y: 148.385,
    width: 118.194,
    height: 73.2853,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.40507,
    result: "effect1_foregroundBlur_6508_4277"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_6508_4277",
    x: 328.048,
    y: 234.851,
    width: 118.194,
    height: 73.2853,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.40507,
    result: "effect1_foregroundBlur_6508_4277"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_6508_4277",
    x: 0.552413,
    y: 221.087,
    width: 120.766,
    height: 77.8177,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.40507,
    result: "effect1_foregroundBlur_6508_4277"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_6508_4277",
    x: 335.184,
    y: 157.618,
    width: 120.766,
    height: 77.8177,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.40507,
    result: "effect1_foregroundBlur_6508_4277"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_6508_4277",
    x: 51.1048,
    y: 282.695,
    width: 111.167,
    height: 102.584,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.40507,
    result: "effect1_foregroundBlur_6508_4277"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_6508_4277",
    x: 294.231,
    y: 71.2432,
    width: 111.167,
    height: 102.584,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.40507,
    result: "effect1_foregroundBlur_6508_4277"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_6508_4277",
    x: 148.376,
    y: 328.063,
    width: 73.2853,
    height: 118.194,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.40507,
    result: "effect1_foregroundBlur_6508_4277"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_6508_4277",
    x: 234.846,
    y: 10.2704,
    width: 73.2853,
    height: 118.194,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.40507,
    result: "effect1_foregroundBlur_6508_4277"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_6508_4277",
    x: 101.548,
    y: 106.286,
    width: 255.446,
    height: 245.924,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.54742,
    result: "effect1_foregroundBlur_6508_4277"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_6508_4277",
    x: 101.548,
    y: 106.286,
    width: 255.446,
    height: 245.924,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.54742,
    result: "effect1_foregroundBlur_6508_4277"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6508_4277",
    x1: 192.125,
    y1: 42.0686,
    x2: 194.681,
    y2: 118.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6508_4277",
    x1: 264.32,
    y1: 414.454,
    x2: 261.764,
    y2: 337.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6508_4277",
    x1: 103.863,
    y1: 85.0777,
    x2: 144.323,
    y2: 150.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6508_4277",
    x1: 352.64,
    y1: 371.445,
    x2: 312.179,
    y2: 306.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6508_4277",
    x1: 48.9418,
    y1: 166.457,
    x2: 116.466,
    y2: 202.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6508_4277",
    x1: 407.56,
    y1: 290.065,
    x2: 340.036,
    y2: 254.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6508_4277",
    x1: 42.0587,
    y1: 264.387,
    x2: 118.553,
    y2: 261.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6508_4277",
    x1: 414.444,
    y1: 192.135,
    x2: 337.95,
    y2: 194.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6508_4277",
    x1: 85.0677,
    y1: 352.65,
    x2: 150.036,
    y2: 312.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6508_4277",
    x1: 371.435,
    y1: 103.872,
    x2: 306.466,
    y2: 144.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6508_4277",
    x1: 166.447,
    y1: 407.576,
    x2: 202.481,
    y2: 340.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6508_4277",
    x1: 290.059,
    y1: 48.9518,
    x2: 254.026,
    y2: 116.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_6508_4277",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(222.92 214.514) rotate(172.388) scale(157.895 122.964)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_6508_4277",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(222.92 214.514) rotate(172.388) scale(157.895 122.964)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6508_4277",
    x1: 174.791,
    y1: 199.132,
    x2: 159.998,
    y2: 246.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6508_4277",
    x1: 260.465,
    y1: 176.186,
    x2: 281.883,
    y2: 223.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6508_4277",
    x1: 175.333,
    y1: 84.7086,
    x2: 230.15,
    y2: 267.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6508_4277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 456.522,
    height: 456.522,
    fill: "white",
    transform: "matrix(-1 0 0 1 456.522 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCovidLowRisk);
export default __webpack_public_path__ + "static/media/covid-low-risk.2f24bb5db84f8d4299cf1dc107d40a43.svg";
export { ForwardRef as ReactComponent };